import axios from "axios";
import ActionCable from "actioncable";
class BaseStore {
  isAuthenticated = this.getLocal("auth") === "true";
  constructor() {
    if (window.axios === undefined)
      window.axios = axios.create({
        baseURL: this.api_url(),
        timeout: 10000
      });

    this.axios = window.axios;
    if (this.isAuthenticated) {
      this.setGlobalHeaders();
    }
  }

  static addInterceptorLoanding(onLoad, onNetworkFail, onError) {
    let timeout = null;
    window.axios.interceptors.request.use(
      r => {
        if (timeout !== null) {
          clearTimeout(timeout);
        }
        timeout = setTimeout(() => onLoad(true), 500);
        return r;
      },
      e => {
        clearTimeout(timeout);
        onLoad(false);
        return Promise.reject(e);
      }
    );
    window.axios.interceptors.response.use(
      r => {
        clearTimeout(timeout);
        onNetworkFail(false);
        onLoad(false);
        return r;
      },
      e => {
        if (!e.status && e.response === undefined) {
          onNetworkFail(true);
        }
        if (e.response.status === 401) {
          localStorage.clear();
          const { response } = e;
          if (response.data.reload === true)
            window.location.replace(
              window.location.href + `?error=${response.data.error}`
            );
        }
        clearTimeout(timeout);
        onLoad(false);
        return Promise.reject(e);
      }
    );
  }

  cable() {
    if (this.cableConsumer === undefined) {
      const proto = window.location.protocol === "https:" ? "wss" : "ws";
      const url = `${proto}://${this.api_domain()}/live?email=${this.email()}&token=${this.token()}`;
      this.cableConsumer = ActionCable.createConsumer(url);
    }
    return this.cableConsumer;
  }

  api_domain() {
    const url = new URL(this.api_url());
    return url.host;
  }

  api_url() {
    return process.env.REACT_APP_API;
  }

  token() {
    return this.getLocal("token");
  }

  email() {
    return this.getLocal("email");
  }

  setGlobalHeaders() {
    axios.defaults.headers.common["Email"] = this.email();
    axios.defaults.headers.common["Token"] = this.token();
  }

  saveLocal(key, object) {
    localStorage.setItem(key, object);
  }

  getLocal(key) {
    return localStorage.getItem(key);
  }

  popLocal(key) {
    const local = this.getLocal(key);
    localStorage.removeItem(key);
    return local;
  }

  error(error) {
    console.error(error);
  }

  isTFA() {
    return this.getLocal("tfa") === "true";
  }

  isAuth() {
    return this.isAuthenticated;
  }
}
export default BaseStore;



// WEBPACK FOOTER //
// ./src/stores/BaseStore.js